import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import * as moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import { DOUBLE_PATTERN } from "../../../@auth/components/constants";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";

import { Person } from "../../../models/person.model";

import Shop from "../../../models/shop.model";
import { CustomerService } from "../../../services/customer.service";

import { Customer } from "../../../models/customer.model";
import WorkingTask from "../../../models/working-task.model";
import { WorkingTaskService } from "../../../services/working-task.service";
import { DialogWorkingTaskComponent } from "../../dialog-working-task/dialog-working-task.component";

@Component({
  selector: "ngx-dialog-view-task",
  templateUrl: "dialog-view-task.component.html",
  styleUrls: ["dialog-view-task.component.scss"],
})
export class DialogViewTaskComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() menu: string = "info"; //info / detail
  @Input() header: string;
  @Input() shopId?: string;
  @Input() shop?: Shop;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() users?: Person[] = [];
  @Input() customer?: Customer;
  @Input() task?: WorkingTask;

  @Input() mode: string; //new/edit

  @ViewChild("title") title: ElementRef;

  loading = false;
  submitted = false;

  constructor(
    protected ref: NbDialogRef<DialogViewTaskComponent>,
    public customerService: CustomerService
  ) {}

  ngOnInit() {
    console.log("🚀 ~ DialogViewTaskComponent ~ task:", this.task);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel() {
    this.ref.close();
  }
}
